import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const StoreCode = ({ codeType }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const code = params.get(codeType);

        if (code) {
            localStorage.setItem(codeType, code);
        }
        // Always redirect after handling code to prevent re-triggering
        navigate('/signup', { replace: true });
    }, []); // Run once on mount – stable behavior

    return null;
};

export default StoreCode;
